import React from "react";
import { ArrowRight, Lock } from "lucide-react";
import { usePrice } from "@/lib/price";

export default function MidCTA() {
  const { price, cap } = usePrice();
  return (
    <section
      data-testid="mid-cta"
      className="border-b-4 border-[#0a0a0a] bg-[#FDFBF7]"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-14 md:py-20">
        <div className="reveal relative bg-[#0a0a0a] text-[#FDFBF7] border-4 border-[#0a0a0a] shadow-brutal-lg p-7 md:p-10 overflow-hidden">
          <div className="absolute -top-16 -right-20 w-[320px] h-[320px] rounded-full bg-[#FFE600]/15 blur-2xl pointer-events-none" />
          <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-center relative">
            <div className="md:col-span-8">
              <div className="font-accent text-xs bg-[#FFE600] text-[#0a0a0a] inline-block px-2.5 py-1 mb-3">
                MID-PAGE · STILL READING?
              </div>
              <h3 className="font-display text-3xl md:text-5xl leading-tight">
                Free to start. Everything for{" "}
                <span className="bg-[#FFE600] text-[#0a0a0a] px-2">{price}</span>.
              </h3>
              <p className="font-mono-body mt-3 text-[#FDFBF7]/75 text-[15px] max-w-xl">
                One-time payment, lifetime access. First {(cap || 2500).toLocaleString()} members lock the
                price. After that it climbs.
              </p>
            </div>
            <div className="md:col-span-4 flex flex-col gap-3 md:items-end">
              <a
                href="https://whop.com/checkout/plan_hfsvR7lsOjQds"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="midcta-lock"
                className="hover-pop w-full md:w-auto inline-flex items-center justify-center gap-2 bg-[#FFE600] text-[#0a0a0a] border-4 border-[#FDFBF7] px-5 py-3.5 font-accent text-base shadow-[6px_6px_0_0_#FDFBF7]"
              >
                <Lock size={15} strokeWidth={3} /> LOCK {price}
                <ArrowRight size={15} strokeWidth={3} />
              </a>
              <a
                href="/login"
                data-testid="midcta-free"
                className="w-full md:w-auto inline-flex items-center justify-center gap-2 bg-transparent text-[#FFE600] border-2 border-[#FFE600] px-5 py-3 font-accent text-base hover:bg-[#FFE600] hover:text-[#0a0a0a]"
              >
                Start free — no card
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
